// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"how-it-works_howItWorks__2M6UX","heading":"how-it-works_heading__LLGEU","description":"how-it-works_description__2VCL0"};